// imports
import React, { useState, useEffect } from 'react';
import TabView from '../../molecules/tabView';
import { LINKS, ROUTES } from '../../constants';
import { IActionItem } from '../../common/types';
import AccountLayout from '../../layouts/account';
import AccountTabView from '../../molecules/tabView/sidebar/accountTabView';

// interfaces / types / consts
interface State { isMobile: boolean }
interface Props { children: JSX.Element | JSX.Element[] }
const NAV_ITEMS: IActionItem[] = [
  { key: 'heroes', url: ROUTES.HERO_COLLECTION },
  { key: 'items', url: ROUTES.ITEM_COLLECTION },
  { key: 'activity', url: ROUTES.ACTIVITY },
  { key: 'account settings', url: ROUTES.SETTINGS },
  { key: 'help', url: LINKS.GIT_BOOK }
];

// exports
export default function Profile(props: Props): JSX.Element {
  const { children } = props;
  // hooks configuration
  const [state, setState] = useState<State>({ isMobile: window.innerWidth < 992 });
  useEffect(() => {
    const handleWindowResize = (): void => setState({ isMobile: window.innerWidth < 992 });
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [state]);

  // render
  return (
    <AccountLayout navItems={state.isMobile ? NAV_ITEMS : []}>
      <TabView className="profile" sidebar={<AccountTabView />}>{children}</TabView>
    </AccountLayout>
  );
}
